import { createFileRoute } from "@tanstack/react-router";
import Typography from "@mui/material/Typography";
import { useGetUsersQuery } from "@/api/ExampleApi.ts";
import AppCard from "@/components/AppCard.tsx";
import { CardContent, CardHeader, Grid } from "@mui/material";
import usePreferencesState from "@/store/hooks.ts";
import { format } from "date-fns";
import { assertAuthenticated } from "@/api/utils.ts";
import { ROLE_i18n_KEY } from "@/constants";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_dashboard/home")({
  component: Index,
  loader: ({ context }) => {
    const { session } = context;
    assertAuthenticated(session);
    return {
      user: session.user,
    };
  },
});

function Index() {
  const preferences = usePreferencesState();
  const { user } = Route.useLoaderData();
  const { t } = useTranslation();

  return (
    <Grid container spacing={6}>
      <Grid size={{ xs: 12 }}>
        <AppCard>
          <CardHeader
            title={`${t("app.label")} React + Symfony  ${format(new Date(), "yyyy")} ⛷️`}
          />
          <CardContent>
            <Typography>
              Front : <strong>React + Vite + Mui</strong>
            </Typography>
            <Typography>
              Back : <strong>Symfony + Api Platform</strong>
            </Typography>
            <Typography variant="body2">{t("home.readme")}</Typography>
          </CardContent>
        </AppCard>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <AppCard>
          <CardHeader title={`${t("home.appState")} 📦`} />
          <CardContent>
            <Typography>
              {t("misc.user")} : <strong>{user.fullName}</strong>
            </Typography>
            <Typography>
              {t("misc.role")} : <strong> {t(ROLE_i18n_KEY[user.role])}</strong>
            </Typography>
            <Typography>
              {t("misc.email")} : <strong>{user.email}</strong>
            </Typography>
            <Typography>
              {t("misc.formGap")} : <strong>{preferences.formGap}</strong>
            </Typography>
            <Typography>
              {t("misc.rootFontSize")} :
              <strong>{preferences.rootFontSize}</strong>
            </Typography>
          </CardContent>
        </AppCard>
      </Grid>
    </Grid>
  );
}
